import {
  CircularProgress,
  Link,
  TableBody,
  TableCell,
  TableRow
} from '@material-ui/core';
import { ReportResponse } from '@react/lib/api/types';
import { useTranslations } from '@react/lib/i18n';
import React from 'react';
import { Waypoint } from 'react-waypoint';
import {
  LoaderWrapper,
  StyledTable,
  StyledTableFooter,
  StyledTableHead,
  StyledTableRow
} from './index.styled';

interface Props {
  data: ReportResponse[];
  loading: boolean;
  onScrollToEnd: () => void;
}

const ReportsTable: React.FunctionComponent<Props> = ({
  data,
  loading,
  onScrollToEnd
}: Props) => {
  const { t } = useTranslations();

  return (
    <>
      <StyledTable>
        <StyledTableHead>
          <TableCell>Id</TableCell>
          <TableCell>File size (bytes)</TableCell>
        </StyledTableHead>
        <TableBody>
          {data.map((report) => (
            <StyledTableRow>
              <TableCell>
                <Link href={report.url}>{report.id}</Link>
              </TableCell>
              <TableCell>{report.sizeBytes}</TableCell>
            </StyledTableRow>
          ))}
        </TableBody>
        <StyledTableFooter>
          <TableRow>
            {loading && (
              <TableCell colSpan={2}>
                <LoaderWrapper data-testid="Loader">
                  <CircularProgress />
                </LoaderWrapper>
              </TableCell>
            )}
          </TableRow>
        </StyledTableFooter>
      </StyledTable>
      <Waypoint onEnter={onScrollToEnd} />
    </>
  );
};

export default ReportsTable;
